import React from 'react';




import Header from './Header';
import Footer from './Footer';
import Solutions from './Solutions';
import FooterBanner from './FooterBanner';

function PrimeSolutions() {
return (
<React.StrictMode>
   <Header/>
   <div className="border-top">
   <Solutions/>
   </div>

   <FooterBanner/>
    <Footer/>
</React.StrictMode>
)
}
export default PrimeSolutions;